import { User } from "@shared/models";

export interface LoginResponse {
    status: boolean;
    token:  string;
    user:   User;
}